// Simulação da API que seria integrada com o sistema de scraping do AppBarber

// Lista simulada de mensalistas
const mensalistas = [
  'Gabriel Ramos',
  'João Silva',
  'Maria Oliveira',
  'Pedro Santos',
  'Ana Costa'
];

// Agenda simulada
const agendaData = [
  { id: 1, clientName: 'Gabriel Ramos', service: 'Corte + Barba', time: '14:00', barber: 'João', date: '2025-04-18' },
  { id: 2, clientName: 'Pedro Santos', service: 'Corte', time: '15:00', barber: 'Carlos', date: '2025-04-18' },
  { id: 3, clientName: 'Ana Costa', service: 'Hidratação', time: '16:00', barber: 'João', date: '2025-04-18' },
  { id: 4, clientName: 'Maria Oliveira', service: 'Corte', time: '16:30', barber: 'Carlos', date: '2025-04-18' },
  { id: 5, clientName: 'João Silva', service: 'Barba', time: '17:00', barber: 'João', date: '2025-04-18' },
  { id: 6, clientName: 'Lucas Mendes', service: 'Corte + Barba', time: '10:00', barber: 'João', date: '2025-04-19' },
  { id: 7, clientName: 'Fernanda Lima', service: 'Corte', time: '11:00', barber: 'Carlos', date: '2025-04-19' },
  { id: 8, clientName: 'Roberto Alves', service: 'Barba', time: '14:00', barber: 'João', date: '2025-04-19' },
];

// Barbeiros simulados
const barbeiros = [
  { id: 1, name: 'João', specialty: 'Corte e Barba' },
  { id: 2, name: 'Carlos', specialty: 'Degradê e Coloração' },
];

// Produtos simulados
const produtos = [
  { id: 1, name: 'Pomada Modeladora', price: 45.90, image: 'pomada.jpg' },
  { id: 2, name: 'Óleo para Barba', price: 39.90, image: 'oleo.jpg' },
  { id: 3, name: 'Shampoo Anticaspa', price: 35.90, image: 'shampoo.jpg' },
  { id: 4, name: 'Pente Profissional', price: 29.90, image: 'pente.jpg' },
];

// Estilos de corte simulados
const estilos = [
  { id: 1, name: 'Degradê Clássico', image: 'degrade.jpg', category: 'Moderno' },
  { id: 2, name: 'Corte Social', image: 'social.jpg', category: 'Clássico' },
  { id: 3, name: 'Undercut', image: 'undercut.jpg', category: 'Moderno' },
  { id: 4, name: 'Barba Cheia', image: 'barba.jpg', category: 'Barba' },
  { id: 5, name: 'Barba Curta', image: 'barba_curta.jpg', category: 'Barba' },
  { id: 6, name: 'Moicano', image: 'moicano.jpg', category: 'Moderno' },
];

// Patrocinadores simulados com suporte para vídeos e imagens
const patrocinadores = [
  { id: 1, name: 'Barbearia Produtos', type: 'image', url: 'sponsor1.jpg', link: 'https://exemplo.com' },
  { id: 2, name: 'Cerveja Artesanal', type: 'video', url: 'sponsor-video.mp4', link: 'https://exemplo.com' },
  { id: 3, name: 'Produtos para Barba', type: 'image', url: 'sponsor3.jpg', link: 'https://exemplo.com' },
  { id: 4, name: 'Curso de Barbeiro', type: 'video', url: 'curso-video.mp4', link: 'https://exemplo.com' },
  { id: 5, name: 'Academia Local', type: 'image', url: 'sponsor5.jpg', link: 'https://exemplo.com' },
  { id: 6, name: 'Loja de Roupas', type: 'image', url: 'sponsor6.jpg', link: 'https://exemplo.com' },
];

// Função para verificar se um cliente é mensalista
export const checkMensalista = (name) => {
  return mensalistas.includes(name);
};

// Função para obter a agenda
export const getAgenda = (date = '2025-04-18') => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(agendaData.filter(item => item.date === date));
    }, 500);
  });
};

// Função para obter os barbeiros
export const getBarbeiros = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(barbeiros);
    }, 300);
  });
};

// Função para obter os produtos
export const getProdutos = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(produtos);
    }, 300);
  });
};

// Função para obter os estilos de corte
export const getEstilos = (category = null) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      if (category) {
        resolve(estilos.filter(estilo => estilo.category === category));
      } else {
        resolve(estilos);
      }
    }, 300);
  });
};

// Função para obter os patrocinadores
export const getPatrocinadores = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(patrocinadores);
    }, 300);
  });
};

// Função para registrar check-in
export const registrarCheckIn = (clientName, time) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        message: `Check-in realizado com sucesso para ${clientName} às ${time}`,
        timestamp: new Date().toISOString()
      });
    }, 500);
  });
};

// Função para registrar check-out
export const registrarCheckOut = (clientName, time) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        message: `Check-out realizado com sucesso para ${clientName} às ${time}`,
        timestamp: new Date().toISOString()
      });
    }, 500);
  });
};

// Função para registrar avaliação
export const registrarAvaliacao = (clientName, rating, comment = '') => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        message: `Avaliação registrada com sucesso para ${clientName}`,
        data: { clientName, rating, comment, timestamp: new Date().toISOString() }
      });
    }, 500);
  });
};
